module.exports = __webpack_public_path__ + "media/images/icons/material/wifi-dfaf6a0c44ad98f863607a75e0473308.svg";